export const PUBLIC_MARKETING_HEADER_COPY_HI = {
  "product": "उत्पाद",
  "solutions": "समाधान",
  "tools": "औजार",
  "resources": "संसाधन",
  "platformExports": "प्लेटफ़ॉर्म निर्यात",
  "metadataTools": "मेटाडेटा उपकरण",
  "display": "प्रदर्शन",
  "displayPreferences": "सेटिंग्स प्रदर्शित करें",
  "zoom": "ज़ूम करें",
  "theme": "थीम",
  "switchTheme": "विषय बदलें",
  "studio": "स्टूडियो खोलें",
  "menu": "मेनू",
  "closeMenu": "मेनू बंद करें",
  "navigation": "मुख्य मेन्यू",
  "navigationDescription": "Stocktag उत्पादों, टूल, संसाधनों और खाता सेटिंग्स का अन्वेषण करें।",
  "account": "खाता",
  "legal": "कानूनी",
  "social": "सामाजिक प्रोफाइल",
  "about": "के बारे में",
  "editorial": "संपादकीय नीति",
  "contact": "संपर्क",
  "privacy": "गोपनीयता सूचना",
  "terms": "सेवा की शर्तें"
};

export const PUBLIC_MARKETING_FOOTER_COPY_HI = {
  "ctaEyebrow": "अपना अगला बैच यहां शुरू करें",
  "ctaTitle": "बाज़ार के लिए तैयार मेटाडेटा के साथ अपनी छवियां प्रकाशित करें।",
  "ctaBody": "एक ही कार्यक्षेत्र से सब कुछ बनाएं, समीक्षा करें और निर्यात करें।",
  "studio": "Metadata Studio खोलें",
  "seePricing": "मूल्य निर्धारण देखें",
  "product": "उत्पाद",
  "tools": "औजार",
  "resources": "संसाधन",
  "account": "खाता",
  "company": "कंपनी",
  "legal": "कानूनी",
  "footerNavigation": "फ़ुटर नेविगेशन",
  "platformExports": "प्लेटफ़ॉर्म निर्यात",
  "metadataTools": "मेटाडेटा उपकरण",
  "tagline": "स्टॉक क्रिएटर्स के लिए एक संपूर्ण मेटाडेटा वर्कफ़्लो।",
  "about": "के बारे में",
  "editorial": "संपादकीय नीति",
  "contact": "संपर्क",
  "privacy": "गोपनीयता सूचना",
  "terms": "सेवा की शर्तें",
  "social": "Stocktag सामाजिक प्रोफ़ाइल"
};

export const PUBLIC_MARKETING_FOOTER_FLOW_HI = {
  "label": "प्रकाशन कार्यप्रवाह",
  "input": "स्रोत छवियाँ",
  "studio": "Metadata Studio",
  "review": "मेटाडेटा की समीक्षा की गई",
  "export": "फ़ाइलें अपलोड करने के लिए तैयार हैं"
};

export const PUBLIC_HOME_UI_COPY_HI = {
  "productSceneAlt": "Stocktag Metadata Studio जेनरेशन सेटिंग्स, अपलोड वर्कस्पेस और मेटाडेटा समीक्षा नियंत्रण के साथ",
  "aiBridgeAlt": "एआई इमेज स्टूडियो में बनाया गया स्थायी शहर चित्रण, Metadata Studio पर अपलोड करने से पहले डाउनलोड करने के लिए तैयार है",
  "heroInputLabel": "स्रोत फ़ाइल",
  "heroAnalyze": "दृश्य विश्लेषण पूर्ण",
  "heroTitleReady": "शीर्षक और कीवर्ड तैयार",
  "heroReadyFor": "Adobe Stock के लिए तैयार",
  "heroFileName": "alpine-hiker.jpg",
  "heroSampleTitle": "सूर्योदय के समय एक शांत अल्पाइन झील को देखता हुआ यात्री",
  "heroKeywords": [
    "पदयात्री",
    "अल्पाइन झील",
    "सूर्योदय"
  ],
  "platformEyebrow": "बाज़ार तैयार",
  "workflowEyebrow": "एक सतत कार्यप्रवाह",
  "exportEyebrow": "अपलोड करने से पहले तैयार",
  "trialEyebrow": "अतिथि डेमो",
  "trialLimit": "प्रत्येक दिन प्रति साइट और आईपी पते पर एक परीक्षण उपलब्ध है। Metadata Studio में अपनी चयनित फ़ाइल के साथ जारी रखें।",
  "videoDuration": "1 मिनट 31 सेकंड",
  "capabilityEyebrow": "हर सुविधा",
  "toolsEyebrow": "कार्य के लिए उपकरण",
  "exploreAllTools": "सभी Stocktag टूल का अन्वेषण करें",
  "marketEyebrow": "बाज़ार आसूचना",
  "sampleSignal": "नमूना संकेत",
  "exploreMarket": "Market Intelligence का अन्वेषण करें",
  "modulesEyebrow": "स्टूडियो उपकरण",
  "exportsEyebrow": "बाज़ार-तैयार फ़ाइलें",
  "generatorEyebrow": "एआई इमेज स्टूडियो",
  "openGenerator": "एआई इमेज स्टूडियो खोलें",
  "generateStep": "उत्पन्न",
  "tagStep": "डाउनलोड करना",
  "exportStep": "अपलोड करें",
  "outputsEyebrow": "एक वास्तविक आउटपुट उदाहरण",
  "copy": "प्रतिलिपि",
  "copied": "नकल की गई",
  "previewOnly": "यह एक चयन योग्य पूर्वावलोकन है. निर्यात Metadata Studio में होता है।",
  "whyEyebrow": "स्टॉक योगदानकर्ताओं के लिए",
  "compareEyebrow": "वर्कफ़्लो तुलना",
  "beforeAfterEyebrow": "मैन्युअल कार्य से नियंत्रित वर्कफ़्लो तक",
  "trustEyebrow": "निर्यात से पहले नियंत्रण",
  "testimonialsEyebrow": "उपयोग के उदाहरण",
  "pricingEyebrow": "सही योजना चुनें",
  "faqEyebrow": "अक्सर पूछे जाने वाले प्रश्न",
  "routesEyebrow": "अन्वेषण करते रहें",
  "finalEyebrow": "इसे अभी आज़माएं",
  "beforeLabel": "Stocktag से पहले",
  "afterLabel": "Metadata Studio के साथ",
  "stocktagLabel": "Stocktag",
  "genericLabel": "सामान्य प्रयोजन एआई",
  "selectedPlatform": "चयनित मंच",
  "formatPreview": "प्रारूप पूर्वावलोकन",
  "workflowImages": [
    "Metadata Studio में फ़ाइलें आयात करना",
    "मेटाडेटा जनरेशन सेटिंग्स",
    "बैच मेटाडेटा समीक्षा",
    "बाज़ार निर्यात नियंत्रण"
  ]
};

export const HOME_SKIP_TO_MAIN_LABEL_HI = "मुख्य सामग्री पर जाएँ";

export const HOME_MAIN_CONTENT_LABEL_HI = "घरेलू सामग्री";


export default PUBLIC_HOME_UI_COPY_HI;
